(function () {
  /* ─── helpers ─── */
  function isMobile() {
    return window.innerWidth <= 767;
  }

  /* =================================================================
     INIT – called once per [data-video-carousel] section
     ================================================================= */
  function initSection(section) {
    if (!section || section.dataset.videoCarouselInitialized === 'true') return;

    var track = section.querySelector('.video-carousel__track');
    if (!track) return;

    var items = Array.prototype.slice.call(
      track.querySelectorAll('.video-carousel__item')
    );
    var prevBtn = section.querySelector('.video-carousel__nav.prev');
    var nextBtn = section.querySelector('.video-carousel__nav.next');

    var totalOriginalItems = parseInt(section.dataset.totalOriginalItems || '0', 10);
    var gap = parseFloat(section.dataset.itemGap || '0');
    var itemWidth = parseFloat(section.dataset.itemWidth || '0') + gap;

    if (!items.length || !totalOriginalItems || !itemWidth) {
      section.dataset.videoCarouselInitialized = 'true';
      return;
    }

    var currentIndex = Math.floor(items.length / 2);
    var trackWindow = track.parentElement;

    /* ── track whether section is in viewport (desktop) ── */
    var sectionVisible = false;

    /* ── desktop: set active & play center video ── */
    function setActiveVideo(index) {
      items.forEach(function (item, idx) {
        var video = item.querySelector('video');
        if (idx === index) {
          item.classList.add('is-active');
          item.classList.remove('is-paused');
          if (video && sectionVisible) {
            video.muted = true; /* stay muted until user clicks */
            video.play().catch(function () { });
          }
        } else {
          item.classList.remove('is-active', 'is-paused');
          if (video) {
            video.muted = true;
            video.pause();
          }
        }
      });
    }

    /* ── mobile: only highlight the center item, don't auto-play ── */
    function setActiveItemMobile(index) {
      items.forEach(function (item, idx) {
        if (idx === index) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active', 'is-paused');
        }
      });
    }

    /* Pause every video in the carousel (used when overlay opens) */
    function pauseAllCarouselVideos() {
      items.forEach(function (item) {
        var v = item.querySelector('video');
        if (v) v.pause();
      });
    }

    /* ── desktop carousel positioning (no play) ── */
    function positionCarousel(animate) {
      if (animate === void 0) animate = true;

      if (!animate) {
        track.style.transition = 'none';
      } else {
        track.style.transition = 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)';
      }

      var containerWidth = track.parentElement.offsetWidth;
      if (!containerWidth) {
        requestAnimationFrame(function () {
          positionCarousel(animate);
        });
        return;
      }

      var offset =
        containerWidth / 2 - currentIndex * itemWidth - itemWidth / 2 + gap / 2;
      track.style.transform = 'translateX(' + offset + 'px)';
    }

    /* ── desktop carousel positioning + play ── */
    function updateCarousel(animate) {
      positionCarousel(animate);
      setActiveVideo(currentIndex);
    }

    function move(direction) {
      currentIndex += direction;
      updateCarousel(true);
    }

    /* ── find the item closest to viewport centre ── */
    function getCenteredItemIndex() {
      var trackRect = trackWindow.getBoundingClientRect();
      var viewportCenter = trackRect.left + trackRect.width / 2;
      var closestIndex = 0;
      var closestDist = Infinity;

      items.forEach(function (item, index) {
        var rect = item.getBoundingClientRect();
        var itemCenter = rect.left + rect.width / 2;
        var dist = Math.abs(itemCenter - viewportCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = index;
        }
      });
      return closestIndex;
    }

    /* ── mobile scroll handling (NO auto-play, just highlight) ── */
    var scrollEndTimer = null;

    function updateActiveFromScroll() {
      if (!isMobile()) return;
      var newIndex = getCenteredItemIndex();
      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        setActiveItemMobile(currentIndex);
      }
    }

    function onScroll() {
      if (!isMobile()) return;
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(updateActiveFromScroll, 200);
    }

    function initMobile() {
      if (!isMobile()) return;
      /* Pause all videos on initial mobile load – they must not auto-play */
      items.forEach(function (item) {
        var v = item.querySelector('video');
        if (v) v.pause();
      });
      currentIndex = getCenteredItemIndex();
      setActiveItemMobile(currentIndex);
    }

    /* ── IntersectionObserver: only play desktop video when section is visible ── */
    if ('IntersectionObserver' in window && !isMobile()) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sectionVisible = entry.isIntersecting;
          if (entry.isIntersecting) {
            /* Section scrolled into view → play active video */
            setActiveVideo(currentIndex);
          } else {
            /* Section left viewport → pause all */
            pauseAllCarouselVideos();
          }
        });
      }, { threshold: 0.3 }); /* trigger when 30% of section is visible */
      observer.observe(section);
    }

    /* ── initial setup ── */
    setTimeout(function () {
      if (isMobile()) {
        initMobile();
      } else {
        /* Position the carousel but don't play — observer handles play */
        positionCarousel(false);
        setActiveVideo(currentIndex); /* will only play if sectionVisible is true */
      }
    }, 150);

    /* nav buttons (desktop) */
    if (prevBtn) prevBtn.addEventListener('click', function () { move(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { move(1); });

    /* infinite loop (desktop) */
    track.addEventListener('transitionend', function () {
      var buffer = totalOriginalItems;
      if (currentIndex < buffer) {
        currentIndex += totalOriginalItems;
        updateCarousel(false);
      } else if (currentIndex >= items.length - buffer) {
        currentIndex -= totalOriginalItems;
        updateCarousel(false);
      }
    });

    /* resize */
    window.addEventListener('resize', function () {
      if (isMobile()) {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(initMobile, 400);
      } else {
        updateCarousel(false);
      }
    });

    /* scroll listener on mobile */
    if (trackWindow.addEventListener) {
      trackWindow.addEventListener('scroll', onScroll, { passive: true });
    }

    /* =================================================================
       MOBILE TAP → open TikTok-style overlay
       ================================================================= */
    items.forEach(function (item, index) {
      item.addEventListener('click', function (e) {
        if (isMobile()) {
          e.preventDefault();
          e.stopPropagation();
          openOverlay(index % totalOriginalItems);
          return;
        }

        /* ── desktop behaviour ── */
        if (currentIndex !== index) {
          currentIndex = index;
          updateCarousel(true);
        } else {
          var video = item.querySelector('video');
          if (video) {
            e.preventDefault();
            e.stopPropagation();
            /* First click on active video → activate sound; further clicks toggle play/pause */
            if (video.muted) {
              video.muted = false;
              if (video.paused) {
                video.play().catch(function () { });
              }
              item.classList.remove('is-paused');
            } else if (video.paused) {
              video.play().catch(function () { });
              item.classList.remove('is-paused');
            } else {
              video.pause();
              item.classList.add('is-paused');
            }
          }
        }
      });
    });

    /* =================================================================
       TIKTOK OVERLAY
       ================================================================= */
    var overlay = null;
    var overlayScroller = null;
    var overlaySlides = [];
    var activeOverlayIndex = -1;

    /* Collect *original* items (first set only, not duplicates) */
    function getOriginalItems() {
      return items.slice(0, totalOriginalItems);
    }

    function openOverlay(startLogical) {
      pauseAllCarouselVideos();

      /* Create overlay DOM */
      overlay = document.createElement('div');
      overlay.className = 'vc-overlay';

      /* Close button – use inline styles as extra insurance against theme overrides */
      var closeBtn = document.createElement('button');
      closeBtn.className = 'vc-overlay__close';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.setAttribute('type', 'button');
      closeBtn.style.cssText = 'position:fixed;top:16px;right:16px;z-index:100001;' +
        'width:40px;height:40px;min-width:40px;min-height:40px;max-width:40px;max-height:40px;' +
        'border-radius:50%;border:none;outline:none;background:rgba(0,0,0,0.45);' +
        'display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;margin:0;' +
        'box-shadow:0 2px 8px rgba(0,0,0,0.3);-webkit-appearance:none;appearance:none;' +
        'backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);overflow:visible;';

      var closeSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      closeSvg.setAttribute('viewBox', '0 0 24 24');
      closeSvg.setAttribute('width', '22');
      closeSvg.setAttribute('height', '22');
      closeSvg.style.cssText = 'display:block;pointer-events:none;fill:#fff;flex-shrink:0;';
      var closePath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      closePath.setAttribute('d', 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z');
      closePath.setAttribute('fill', '#ffffff');
      closeSvg.appendChild(closePath);
      closeBtn.appendChild(closeSvg);
      overlay.appendChild(closeBtn);

      /* Navigation arrows container */
      var navArrows = document.createElement('div');
      navArrows.className = 'vc-overlay__nav-arrows';
      navArrows.style.cssText = 'position:fixed;right:14px;top:50%;transform:translateY(-50%);z-index:100001;' +
        'display:flex;flex-direction:column;gap:12px;';

      /* Up arrow */
      var arrowUp = document.createElement('button');
      arrowUp.className = 'vc-overlay__arrow vc-overlay__arrow--up';
      arrowUp.setAttribute('aria-label', 'Previous video');
      arrowUp.setAttribute('type', 'button');
      arrowUp.style.cssText = 'width:40px;height:40px;min-width:40px;min-height:40px;max-width:40px;max-height:40px;' +
        'border-radius:50%;border:none;outline:none;background:rgba(0,0,0,0.45);' +
        'display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;margin:0;' +
        'box-shadow:0 2px 8px rgba(0,0,0,0.3);-webkit-appearance:none;appearance:none;' +
        'backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);';
      var upSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      upSvg.setAttribute('viewBox', '0 0 24 24');
      upSvg.setAttribute('width', '22');
      upSvg.setAttribute('height', '22');
      upSvg.style.cssText = 'display:block;pointer-events:none;fill:#fff;flex-shrink:0;';
      var upPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      upPath.setAttribute('d', 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z');
      upPath.setAttribute('fill', '#ffffff');
      upSvg.appendChild(upPath);
      arrowUp.appendChild(upSvg);

      /* Down arrow */
      var arrowDown = document.createElement('button');
      arrowDown.className = 'vc-overlay__arrow vc-overlay__arrow--down';
      arrowDown.setAttribute('aria-label', 'Next video');
      arrowDown.setAttribute('type', 'button');
      arrowDown.style.cssText = arrowUp.style.cssText; /* same styles */
      var downSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      downSvg.setAttribute('viewBox', '0 0 24 24');
      downSvg.setAttribute('width', '22');
      downSvg.setAttribute('height', '22');
      downSvg.style.cssText = 'display:block;pointer-events:none;fill:#fff;flex-shrink:0;';
      var downPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      downPath.setAttribute('d', 'M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z');
      downPath.setAttribute('fill', '#ffffff');
      downSvg.appendChild(downPath);
      arrowDown.appendChild(downSvg);

      navArrows.appendChild(arrowUp);
      navArrows.appendChild(arrowDown);
      overlay.appendChild(navArrows);

      /* Scroll container (vertical snap) */
      overlayScroller = document.createElement('div');
      overlayScroller.className = 'vc-overlay__scroller';
      overlay.appendChild(overlayScroller);

      /* Create one slide per original video */
      overlaySlides = [];
      var originals = getOriginalItems();
      originals.forEach(function (origItem, idx) {
        var slide = document.createElement('div');
        slide.className = 'vc-overlay__slide';
        slide.dataset.index = idx;

        var video = origItem.querySelector('video');
        if (video) {
          var clone = video.cloneNode(true);
          clone.removeAttribute('autoplay');
          clone.muted = true; /* start muted so autoplay is allowed by browser policy */
          clone.loop = true;
          clone.playsInline = true;
          clone.setAttribute('playsinline', '');
          clone.removeAttribute('muted'); /* remove HTML attribute – we unmute via JS after play */
          clone.className = 'vc-overlay__video';
          slide.appendChild(clone);

          /* tap-to-pause/play inside overlay */
          var pauseIcon = document.createElement('div');
          pauseIcon.className = 'vc-overlay__pause-icon';
          pauseIcon.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="64" height="64"><path d="M8 5v14l11-7z" fill="#fff"/></svg>';
          slide.appendChild(pauseIcon);

          (function (vid, icon, sl) {
            /* Tap the video → first tap activates sound, further taps toggle play/pause */
            vid.addEventListener('click', function (ev) {
              ev.stopPropagation();
              if (vid.muted) {
                vid.muted = false;
                if (vid.paused) {
                  vid.play().catch(function () { });
                }
                icon.classList.remove('is-visible');
              } else if (vid.paused) {
                vid.play().catch(function () { });
                icon.classList.remove('is-visible');
              } else {
                vid.pause();
                icon.classList.add('is-visible');
              }
            });
            /* Tap the slide background (outside video) → close overlay */
            sl.addEventListener('click', function (ev) {
              if (ev.target.closest('.vc-overlay__close') || ev.target.closest('.vc-overlay__arrow')) return;
              if (ev.target.closest('.vc-overlay__video')) return; /* let the video handler deal with it */
              closeOverlay();
            });
          })(clone, pauseIcon, slide);
        } else {
          /* If there's an image instead */
          var img = origItem.querySelector('img');
          if (img) {
            var cloneImg = img.cloneNode(true);
            cloneImg.className = 'vc-overlay__video';
            slide.appendChild(cloneImg);
          }
          /* Tap background on non-video slides → close */
          slide.addEventListener('click', function (ev) {
            if (ev.target.closest('.vc-overlay__close') || ev.target.closest('.vc-overlay__arrow')) return;
            if (ev.target.closest('.vc-overlay__video')) return;
            closeOverlay();
          });
        }

        overlaySlides.push(slide);
        overlayScroller.appendChild(slide);
      });

      document.body.appendChild(overlay);
      /* Prevent body scroll */
      document.body.style.overflow = 'hidden';

      /* Force layout so CSS transition triggers */
      overlay.offsetHeight; // eslint-disable-line no-unused-expressions
      overlay.classList.add('is-open');

      /* Scroll to the tapped video */
      requestAnimationFrame(function () {
        var target = overlaySlides[startLogical];
        if (target) {
          overlayScroller.scrollTo({ top: target.offsetTop, behavior: 'instant' });
        }
        activeOverlayIndex = startLogical;
        playOverlaySlide(startLogical);
        updateArrowStates();
      });

      /* Snap-based scroll detection */
      var overlayScrollTimer = null;
      overlayScroller.addEventListener(
        'scroll',
        function () {
          clearTimeout(overlayScrollTimer);
          overlayScrollTimer = setTimeout(onOverlayScrollEnd, 150);
        },
        { passive: true }
      );

      /* Close */
      closeBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        closeOverlay();
      });

      /* Arrow navigation */
      arrowUp.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (activeOverlayIndex > 0) {
          navigateOverlay(activeOverlayIndex - 1);
        }
      });
      arrowDown.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (activeOverlayIndex < overlaySlides.length - 1) {
          navigateOverlay(activeOverlayIndex + 1);
        }
      });

      /* Store arrow refs for state updates */
      overlay._arrowUp = arrowUp;
      overlay._arrowDown = arrowDown;
    }

    function updateArrowStates() {
      if (!overlay) return;
      var up = overlay._arrowUp;
      var down = overlay._arrowDown;
      if (up) {
        if (activeOverlayIndex <= 0) {
          up.setAttribute('disabled', '');
          up.style.opacity = '0.3';
          up.style.cursor = 'default';
        } else {
          up.removeAttribute('disabled');
          up.style.opacity = '1';
          up.style.cursor = 'pointer';
        }
      }
      if (down) {
        if (activeOverlayIndex >= overlaySlides.length - 1) {
          down.setAttribute('disabled', '');
          down.style.opacity = '0.3';
          down.style.cursor = 'default';
        } else {
          down.removeAttribute('disabled');
          down.style.opacity = '1';
          down.style.cursor = 'pointer';
        }
      }
    }

    function navigateOverlay(idx) {
      if (idx < 0 || idx >= overlaySlides.length) return;
      var target = overlaySlides[idx];
      if (target && overlayScroller) {
        overlayScroller.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
      }
      playOverlaySlide(idx);
      updateArrowStates();
    }

    function playOverlaySlide(idx) {
      overlaySlides.forEach(function (slide, i) {
        var vid = slide.querySelector('video');
        var icon = slide.querySelector('.vc-overlay__pause-icon');
        if (i === idx) {
          if (vid) {
            vid.currentTime = 0;
            vid.muted = true; /* stay muted until user taps */
            vid.play().catch(function () { });
          }
          if (icon) icon.classList.remove('is-visible');
        } else {
          if (vid) {
            vid.muted = true;
            vid.pause();
          }
        }
      });
      activeOverlayIndex = idx;
    }

    function onOverlayScrollEnd() {
      if (!overlayScroller) return;
      var scrollTop = overlayScroller.scrollTop;
      var best = 0;
      var bestDist = Infinity;

      overlaySlides.forEach(function (slide, i) {
        var dist = Math.abs(slide.offsetTop - scrollTop);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });

      if (best !== activeOverlayIndex) {
        playOverlaySlide(best);
        updateArrowStates();
      }
    }

    function closeOverlay() {
      if (!overlay) return;

      /* Pause all overlay videos */
      overlaySlides.forEach(function (slide) {
        var vid = slide.querySelector('video');
        if (vid) vid.pause();
      });

      overlay.classList.remove('is-open');
      setTimeout(function () {
        if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
        overlay = null;
        overlayScroller = null;
        overlaySlides = [];
        activeOverlayIndex = -1;
        document.body.style.overflow = '';
      }, 300);
    }

    section.dataset.videoCarouselInitialized = 'true';
  }

  /* =================================================================
     Auto-init
     ================================================================= */
  function initAll() {
    document.querySelectorAll('[data-video-carousel]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
